import { Component, HostBinding, Input, OnChanges } from '@angular/core';
import { Image } from '@features/summary-blind-gallery/components/blind-images/blind-images.component';
import { ScreenshotToBlindService } from '@core/services/screenshot-to-blind/screenshot-to-blind.service';

@Component({
	selector: 'app-blind-image',
	templateUrl: './blind-image.component.html',
	styleUrl: './blind-image.component.scss',
})
export class BlindImageComponent implements OnChanges {
	@Input() image: Image;

	@HostBinding('class') get hostClass() {
		return ['mc-gallery__blind-image', this.image.type, this.image.loading || !this.isScreenshotLoaded ? 'loading' : ''];
	}

	protected imageQueryString = '';

	protected get isScreenshotLoaded(): boolean {
		const loaded = this.screenshotToBlindService.isScreenshotLoadedOnServer;
		return this.image.name === 'main' && typeof loaded === 'boolean' ? loaded : true;
	}

	constructor(protected screenshotToBlindService: ScreenshotToBlindService) {}

	ngOnChanges() {
		this.imageQueryString = this.image.name === 'main' ? this.screenshotToBlindService.screenshotQueryString : '';
	}

	protected onImgLoad(): void {
		if (this.image) {
			this.image.loading = false;
		}
	}
}
